import { query } from '@confluence/query-preloader-tools';

import { ONBOARDING_EXPERIENCES } from '../../constants/onboarding-state/onboarding-constants';
import { EDITOR_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-editor-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadNthUserGettingStartedOnboardingState = () => {
	return query({
		query: getOnboardingStateGQL,
		variables: {
			key: [
				// Shared between flag and banner
				ONBOARDING_EXPERIENCES.IMPROVED_GET_STARTED_NTH_USER_PATH,

				// Flag only - likely doesn't show on server side rendering but preloading for consistency
				ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_FLAG_VIEWED,
				ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP,
				ONBOARDING_EXPERIENCES.NTH_USER_ONBOARDING_PAGE_VIEWED,

				// Banner only
				ONBOARDING_EXPERIENCES.NTH_USER_BANNER_DISMISSED,
				EDITOR_ONBOARDING_STATE_KEYS.HAS_USER_PUBLISHED,
			],
		},
	});
};
